import { render, staticRenderFns } from "./form-log-clinics.vue?vue&type=template&id=f581f072&"
import script from "./form-log-clinics.vue?vue&type=script&lang=js&"
export * from "./form-log-clinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports